<template>
<Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
>
    <template slot="header"> 
    </template>
    <template slot="body">

        <SalesImportInfo 
            style="cursor:copy;background-color: white"
            :selectedStatementDetails="selectedStatementDetails" 
        />
     </template>
    <template slot="options">
      
        <!-- <button  class="dt-button s7" @click="onCancelClick">Close</button> -->
        <!-- <button class="dt-button s7 v1" @click="onOKClicked">OK</button> -->
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';

import { DTIconButton } from "../../../../plugins/button/button";
import { DistributionStatementService } from '../../services/statement.service';

import SalesImportInfo from './sales-import-info.vue'


export default {
  components: {
    
    Modal,

    DTIconButton,
    SalesImportInfo
    //AdvanceSearch,
   
  },
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  mounted:async  function () {
    //DistributionStatementService
  },
  data: function () {
    return {
        isLoading:true,
    
    };
  },
   mixins: [],

  computed: {
   
    
  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
  
  },
};
</script>

<style lang="scss">

</style>